<template>
  <div class="news-page">
    <LayoutDefault
      isShowHeader
      :title="activeTab === 3 ? 'Порядок товаров' : 'Товары'"
      :visibleClose="activeTab === 3"
    >
      <TheToolbar
        v-if="activeTab !== 3"
        @click-plus="goToEditor(0)"
        @click-trash="deleteProduct"
        @click-copy="cloneProduct"
        :selected-row-table="selectedRowTableId"
        :buttons="activeTab !== 3"
        :tabs-list="tabsList"
        :activeTab="activeTab"
        @select-tab="onSelectTab"
      />

      <!-- <div
        class="table-item"
        v-for="table in tabsList"
        :key="table.Id"
      > -->
        <ListTable
          :data="dataSource"
          :policies="cutPolicies(policies, 'Products')"
          header-html
          @row-selected="onRowSelect"
          @redirect-to-editor="goToEditor"
          @row-edit="onRowEditSave"
          v-if="activeTab !== 3"
          :visibleDirectionSort="false"
        />
        <ListProducts v-if="activeTab === 3"/>
      <!-- </div> -->
    </LayoutDefault>
  </div>
</template>

<script>
import { onMounted, computed, ref } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'
import { useRoute } from 'vue-router'

import LayoutDefault from '@/layout/LayoutDefault.vue'
import TheToolbar from '@/components/blocks/TheToolbar.vue'
import ListTable from '@/components/blocks/ListTable.vue'
import ListProducts from '@/components/blocks/ListProducts'

import { cutPolicies } from '@/helpers/policiesValidator.js'

export default {
  name: 'ProductsView',
  components: {
    LayoutDefault,
    ListTable,
    TheToolbar,
    ListProducts
  },
  setup () {
    const store = useStore()
    const route = useRoute()

    onMounted(() => {
      // запрашиваем данные при монтировании компонента
      if (+route.params.tabId !== 3) {
        store.dispatch('setProductsDataTable', tabsList.value[route.params.tabId].Slug)
      } else {
        onSelectTab(3)
      }
    })

    const policies = computed(() => store.getters.getPolicies)

    const dataSource = computed(() => {
      // данные для отрисовки таблицы
      return store.getters.getProductsDataTable
    })

    const activeTab = computed(() => +route.params.tabId)

    const tabsList = ref([
      {
        Id: 0,
        Name: 'Производство',
        Slug: '/api/Products',
        img: '/img/icons/productionIcon.png'
      },
      {
        Id: 1,
        Name: 'Инжиниринговые услуги',
        Slug: '/api/Utilities/GetAllByUniversalTag/4',
        img: '/img/icons/engeeniringIcon.svg'
      },
      {
        Id: 2,
        Name: 'Разработка ПО',
        Slug: '/api/Utilities/GetAllByUniversalTag/5',
        img: '/img/icons/programmIcon.svg'
      },
      {
        Id: 3,
        Name: 'Порядок товаров',
        img: '/img/icons/moveIcon.svg'
      }
    ])

    const onSelectTab = (id) => {
      // сохраняем активный таб в праметр роутера для работы с перезагрузкой
      router.push(`/products/${id}`)

      // перезапрашиваем данные таблички
      if (id !== 3) {
        store.dispatch('setProductsDataTable', tabsList.value[id].Slug)
      } else {
        store.dispatch('SetA_ActivityList')
      }
    }

    const selectedRowTableId = ref(0) // id товара по выбранной строке в таблице

    const onRowSelect = (e) => {
      // функция слушает событие выбора строки в таблице
      // получает id товара
      selectedRowTableId.value = e.data.Id
    }

    const goToEditor = (id) => {
      // переход на страницу редактора
      // если передать 0 то пустая форма
      switch (activeTab.value) {
        case 0 :
          router.push(`/products/editor/${id}`)
          break
        case 1 :
          router.push(`/products/EngineeringEditor/${id}`)
          break
        case 2 :
          router.push(`/products/DevelopmentEditor/${id}`)
          break
        default :
          router.push(`/products/editor/${id}`)
      }
    }

    const deleteProduct = async () => {
      // инициирует запрос на удаление товара
      // store.dispatch('setDeleteProducts', selectedRowTableId.value)
      switch (activeTab.value) {
        case 0 :
          await store.dispatch('setDeleteProducts', `/api/Products/${selectedRowTableId.value}`)
          break
        case 1 :
        case 2 :
          await store.dispatch('setDeleteProducts', `/api/Utilities/${selectedRowTableId.value}`)
          break
        default :
          await store.dispatch('setDeleteProducts', `/api/Products/${selectedRowTableId.value}`)
      }
      // заново запрашиваем данные в табличку
      store.dispatch('setProductsDataTable', tabsList.value[activeTab.value].Slug)
    }

    const cloneProduct = async () => {
      // инициирует клонирование товара
      // store.dispatch('setCloneProducts', selectedRowTableId.value)

      switch (activeTab.value) {
        case 0 :
          await store.dispatch('setCloneProducts', `/api/Products/Clone/${selectedRowTableId.value}`)
          break
        case 1 :
        case 2 :
          await store.dispatch('setCloneProducts', `/api/Utilities/NewClone/${selectedRowTableId.value}`)
          break
        default :
          await store.dispatch('setCloneProducts', `/api/Products/Clone/${selectedRowTableId.value}`)
      }
      // заново запрашиваем данные в табличку
      store.dispatch('setProductsDataTable', tabsList.value[activeTab.value].Slug)
    }

    const onRowEditSave = async (event) => {
      // при редактировании строки таблицы на предмет публикации
      // и готовности к публикации
      const params = {
        obj: {
          ReadyToPublishStatus: event.newData.ReadyToPublish,
          PublishedStatus: event.newData.Published,
          Id: event.newData.Id
        },
        url: ''
      }

      switch (activeTab.value) {
        case 0 :
          params.url = `/api/Products/SetStatuses/${selectedRowTableId.value}`
          await store.dispatch('setStatusProductsTable', params)
          break
        case 1 :
        case 2 :
          params.url = `/api/Utilities/SetStatuses/${selectedRowTableId.value}`
          await store.dispatch('setStatusProductsTable', params)
          break
        default :
          params.url = `/api/Products/SetStatuses/${selectedRowTableId.value}`
          await store.dispatch('setStatusProductsTable', params)
      }

      // а это чтобы в таблице сразу менялись данные не дожидаясь выполнения запроса
      const { newData, index } = event
      dataSource.value[index] = newData
      // заново запрашиваем данные в табличку
      store.dispatch('setProductsDataTable', tabsList.value[activeTab.value].Slug)
    }

    return {
      dataSource,
      tabsList,
      activeTab,
      onSelectTab,
      policies,
      cutPolicies,
      deleteProduct,
      cloneProduct,
      selectedRowTableId,
      onRowSelect,
      goToEditor,
      onRowEditSave
    }
  }
}
</script>

<style lang="scss" scoped>
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(1000px);
}
</style>
